// extracted by mini-css-extract-plugin
module.exports = {"container":"e_tx","widget":"e_ux","title":"e_vx","msrp":"e_wx","separator":"e_xx","textBadge":"e_yx"};